// Gestión de turnos y reservas

import { 
  getTurnos,
  actualizarTurno as actualizarTurnoApi,
  traerHorariosAtencion 
} from "../../apiClient/rutes/turnos";
import {
  filtrarTurnosPorFechaYHora,
  filtrarTurnosPorRestricciones,
  obtenerFechasTurnos,
  obtenerProximosTurnos
} from "./nuevoTurnoUtils";
import { ordenarArrayObjetosByDate } from "../../utils/funcionalidadesArrays";

export const procesarTurnosAgenda = async (config, prestador, horarios, atiende, usuario, urlAxioPP) => {
  try {
    const { turnosDadosMutual, turnosDisponibles } = await getTurnos(
      usuario.token,
      prestador,
      urlAxioPP,
      usuario.codigo,
    );

    const turnosFiltradosPorFechaYHora = filtrarTurnosPorFechaYHora(turnosDisponibles);

    const turnosFiltradosPorRestricciones = filtrarTurnosPorRestricciones(
      turnosFiltradosPorFechaYHora,
      atiende,
      turnosDadosMutual,
      usuario
    );

    const fechasTurnos = obtenerFechasTurnos(turnosFiltradosPorRestricciones);

    const turnosProximos = obtenerProximosTurnos(
      fechasTurnos,
      horarios,
      turnosFiltradosPorRestricciones
    );

    return {
      turnosProximos: ordenarArrayObjetosByDate(turnosProximos, "date"),
      turnosDisponibles: ordenarArrayObjetosByDate(turnosFiltradosPorRestricciones, "hora"),
      fechaSeleccionada: turnosProximos.length > 0 ? turnosProximos[0].date : ""
    };
  } catch (error) {
    throw new Error("Error al procesar los turnos de la agenda: " + error.message);
  }
};

export const manejarReservaTurno = async (turnoSeleccionado, usuario, prestadorSeleccionado, urlAxioPP) => {
  try {
    const response = await actualizarTurnoApi(turnoSeleccionado, usuario, prestadorSeleccionado, urlAxioPP);
    
    if (response.status === 200) {
      return { success: true, mensaje: "El turno se reservó correctamente" };
    } else {
      return { success: false, mensaje: "Ocurrió un problema al intentar reservar el turno" };
    }
  } catch (error) {
    return { 
      success: false, 
      mensaje: error.response?.data || "Error al reservar el turno: " + error.message 
    };
  }
};

export const obtenerHorariosYTurnos = async (prestador, usuario, urlAxioPP) => {
  try {
    const { horarios, atiende } = await traerHorariosAtencion(prestador, usuario, urlAxioPP);
    
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };
    
    const [prestadorCodigo] = prestador.split("-");
    
    const resultadoTurnos = await procesarTurnosAgenda(
      config, 
      prestadorCodigo, 
      horarios, 
      atiende, 
      usuario, 
      urlAxioPP
    );
    
    return {
      success: true,
      ...resultadoTurnos
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
      turnosProximos: [],
      turnosDisponibles: [],
      fechaSeleccionada: ""
    };
  }
};
